/* global $ */

import React, { Component } from 'react';
import {calcArrayPercentages} from '../../lib/analytics.js';

export class OperatingSystem extends Component {

    constructor(props) {
        super(props);
        this.chart = undefined;
    }

    componentDidMount() {
        var self = this;
        this.chart = $(this.refs.operatingSystem).highcharts({
            colors: ['#5c2d91'],
            chart: {
                type: 'column',
                height: '320px',
                reflow: true
            },
            title: {
                text: null
            },
            xAxis: {
                categories: ['<i class="icon-apple charts"></i><br/>Apple iOS',
                    '<i class="icon-android charts"></i><br/>Android',
                    '<i class="icon-windows charts"></i><br/>Windows',
                    '<i class="icon-blackberry charts"></i><br/>Blackberry',
                    '<i class="icon-mobile charts"></i><br/>' + self.props.showMessage('message_18_01')],
                labels: {
                    style: {
                        color: '#454d50',
                        font: '14px "Open Sans", Verdana, sans-serif',
                        textAlign: 'center'
                    },
                    autoRotation: [-90],
                    useHTML: true,
                    formatter: function() {
                        return this.value;
                    }
                },
                lineWidth: 0,
                tickLength: 0
            },
            yAxis: {
                min: 0,
                max: 100,
                title: {
                    text: null
                }
            },
            legend: {
                enabled: false
            },
            tooltip: {
                formatter: function() {
                    return this.x + "<br /><b>" + this.point.y + "%</b>";
                }
            },
            credits: {
                enabled: false
            },
            series: [{
                data: undefined
            }]
        });
        this.updateChart();
    }

    componentDidUpdate() {
        this.updateChart();
    }

    updateChart() {
        this.chart.highcharts().xAxis[0].update({
            categories: ['<i class="icon-apple charts"></i><br/>Apple iOS',
                '<i class="icon-android charts"></i><br/>Android',
                '<i class="icon-windows charts"></i><br/>Windows',
                '<i class="icon-blackberry charts"></i><br/>Blackberry',
                '<i class="icon-mobile charts"></i><br/>' + this.props.showMessage('message_18_01')]
        })
    }

    componentWillReceiveProps(props) {
        this.chart.highcharts().series[0].setData(calcArrayPercentages(props.data), true);
    }

    render() {
        return (
            <div ref='operatingSystem'>
            </div>
        )
    };
}


// WEBPACK FOOTER //
// ./src/components/analytics/OperatingSystem.jsx